import React from 'react';
import PageContainer from '../PageContainer';
import Slider from '../slider/slider';
import { greyText } from '../styles';
import './about.scss';
import about1 from '../images/about-1.jpg'
import about2 from '../images/about-2.jpg'
import { MediaQueryContext } from '../MediaQueryContext';
import PageTitle from '../PageTitle';
import arkivet from './arkivet-logo.svg';

const slides = [
  <div className="about-slide with-image" >
    <div className="image-container">
      <img src={about1} alt="Close-up of a tatoo" />

    </div>

    <div className="slide-content with-title">
      <h1>Skin Remembers</h1>
      <div className="scrollable not-mobile">
        <h2>Stories and identities of the few</h2>
        <p style={{ color: 'white' }}>Individuals with a minority background from Iraq, Palistine, Syria and Sàpmi share their thoughts and feelings on identity.</p>
        <p style={{ color: 'white' }}>This exhibition presents a collection of minority stories and woven identities expressed through a variety of creative forms. Through film, photography, animation, dance, music and poetry, we meet a diverse group of individuals, and become more familiar with their experiences and unique identities.</p>
        <p style={{ color: 'white' }}>By acknowledging these stories, we aim to promote an inclusive and diverse society, where all people feel valued and free to be themselves. We hope that this exhibition will be one small - but important step, towards fighting xenophobia.</p>
        <p style={{ color: 'white' }}>The views and opinions expressed in the Skin Remembers exhibition do not necessarily reflect those of ARKIVET Peace and Human Rights Center and its employees.</p>
        <p style={{ color: greyText }}>Individer med minoritetsbakgrunn fra Irak, Palistina, Syria og Sàpmi forteller om tanker og følelser knyttet til sin identitet.</p>
        <p style={{ color: greyText }}>Denne utstillingen presenterer en samling minoritetshistorier og sammenvevde identiteter som kommer til uttrykk gjennom et mangfold av kreative uttrykk. Gjennom film, foto, animasjon, dans, musikk og poesi møter vi en variert gruppe mennesker og blir bedre kjent med deres bakgrunn og deres unike identiteter.</p>
        <p style={{ color: greyText }}>Ved å anerkjenne disse historiene, ønsker vi å fremme et inkluderende samfunn hvor alle mennesker føler seg verdsatt og har friheten til å være seg selv. Vi håper utstillingen er et lite, men viktig steg mot bekjempelse av fremmedfrykt.</p>
        <p style={{ color: greyText }}>Uttalelser og meninger uttrykt i utstillingen Skin Remembers er ikke nødvendigvis representative for ARKIVET freds- og menneskerettighetssenter og dets ansatte. </p>

      </div>

    </div>

  </div>,


  <div className="about-slide with-image" >
    <div className="image-container">
      <img src={about2} alt="Close-up of womans face in shadow" />

    </div>

    <div className="slide-content">
      <h2>IDENTITY <span style={{ color: greyText }}>IDENTITET</span></h2>
      <div className="scrollable not-mobile">

        <p style={{ color: 'white' }}>Identity is partly built up by many small stories. Each of these individual stories are part of a greater narrative - one that lays the foundation for our cultures. It is important that these larger narratives are not reduced to a single narrative in which we only have one way of understanding the world, and consequently start fearing the other. In order to reject such narratives, it is important that all people are given a voice to express themselves and share their stories. This is especially important for individuals who have been silenced and oppressed because of their identity. Storytelling is therefore a powerful tool that can build bridges between people and expand our understanding of the world.</p>
        <p style={{ color: 'white' }}>When sharing their stories, the participants in this exhibition have taken it upon themselves to counter the single narrative and enrich the collective memory. This is admirable and brave.</p>

        <p style={{ color: greyText }}>Identitet er delvis bygd opp av mange små fortellinger. Disse små, individuelle fortellingene er alle del av et større narrativ, som igjen legger grunnlaget for våre kulturer. Det er viktig at disse store narrativene ikke blir redusert til ett eneste narrativ, slik at vi bare får én måte å forstå verden på - og som en konsekvens begynner å frykte de andre. For å unngå slike ensidige narrativer, er det viktig at mennesker får muligheten til å uttrykke seg og dele sine historier med andre. Dette er spesielt viktig for individer som har blitt undertrykt og nektet ytringsfrihet på bakgrunn av deres identitet. Historiefortelling er derfor et kraftfullt redskap som kan bygge broer mellom mennesker og utvide vår forståelse av verden.</p>
        <p style={{ color: greyText }}>Individene i utstillingen har tatt på seg ansvaret med å utfordre det ensidige narrativet og berike det kollektive minnet med sine historier. Dette er beundringsverdig og modig.</p>

      </div>
    </div>

  </div>,


  <div className="about-slide" >

    <div className="slide-content">
      <h2>BEING ONE OF THE FEW <span style={{ color: greyText }}>Å VÆRE EN AV DE FÅ</span></h2>

      <p style={{ color: 'white' }}>The term “minority” is a contextual concept. Persons with a certain religious or ethnic identity may be in a numerical minority position in one country or region, and in a majority position in another. Indeed, in some countries the numerical minority is in a dominant political position. However, in most situations being the numerical minority makes individuals more vulnerable to discrimination, exclusion and (in some countries and periods) to persecution based on their religious or ethnic identity or group affiliation.</p>

      <p style={{ color: greyText }}>Begrepet «minoritet» er et kontekstuelt konsept. Personer med en bestemt religiøs eller etnisk identitet kan være i numerisk mindretall i ett land, og samtidig i flertall i et annet. I noen land er også det numeriske mindretallet i en dominerende politisk posisjon. I de fleste tilfeller er likevel numerisk mindretall årsaken til at individer er mer sårbare for diskriminering, ekskludering og - i noen land tidvis også forfulgt - på bakgrunn av deres religiøse eller etniske identitet eller gruppetilhørighet.</p>
    </div>

  </div>,


  <div className="about-slide" >

    <div className="slide-content scrollable not-mobile">

      <h2>
        <span style={{ color: 'white' }}>The Skin Remembers exhibition was produced by ARKIVET - Peace and Human Rights Centre </span>
        <br />
        <span style={{ color: greyText }}>Utstillingen Skin Remembers er produsert av ARKIVET freds- og menneskerettighetssenter </span>
      </h2>

      <p style={{ fontSize: '1.2em' }}>
        <span style={{ color: 'white' }}>A special thank you to those who shared their stories and experiences for this exhibition. We stand in solidarity with you.  </span>
        <br />
        <span style={{ color: greyText }}>En spesiell takk går til de som har delt sine historier og erfaringer i denne utstillingen. Vi står i solidaritet med dere. </span>
      </p>

      <p style={{ fontSize: '1.2em' }}>
        <span style={{ color: 'white' }}>We are greatful to Agder Fylkeskommune for supporting this online exhibition.</span>
        <br />
        <span style={{ color: greyText }}>Vi er takknemlig for Agder Fylkeskommunes støtte til denne nettutstillingen.</span>
      </p>




      <div className="spilt">
        <div>
          <strong style={{ color: 'white' }}>Exhibition curated by: </strong>
          <strong style={{ color: greyText }}>Utstilling kuratert av: </strong>

          <br />
          <i style={{ color: 'white' }}>Solveig Hessaa Szwinto, ARKIVET freds- og menneskerettighetssenter </i>
          <br />
          <i style={{ color: 'white' }}>Katrina Flett Gulbrandsen </i>
          <p>
            <strong style={{ color: 'white' }}>Graphic design by:</strong>
            <br />
            <i style={{ color: 'white' }}>Lasse Spilling - 07 Media.</i>

          </p>
          <p>
            <strong style={{ color: 'white' }}>Web development by:</strong>
            <br />
            <i style={{ color: 'white' }}>Matthew Hessaa-Szwinto</i>
          </p>
        </div>
        <a className="ark-logo" href="https://arkivet.no/" target="_blank" ><img src={arkivet} width="300" alt="Arkivets logo" /></a>

      </div>
    </div>


  </div>,
  <div className="about-slide" >

    <div className="slide-content">
      <h2>
        <span style={{ color: 'white' }}>Kindly supported by: </span>
        <span style={{ color: greyText }}>Støttet av:</span>
      </h2>

      <br />
      <i>Fritt Ord</i>
      <br />
      <i>Gjensidigestiftelsen</i>
      <br />
      <i>HL-SENTERET The Norwegian Center for Holocaust and Minority Studies</i>
      <br />
      <i>Kilden Performing Arts Centre</i>
      <br />
      <i>Kulturrådet Arts Council Norway</i>
      <br />
      <i>Plattform The Norwegian Institute for the Prevention of Radicalization and Violent Extremism</i>
      <br />
      <i>Agder fylkeskommune</i>

    </div>

  </div>

];

class About extends React.Component {
  static contextType = MediaQueryContext;

  render() {
    return (
      <PageContainer {...this.props} className="about" >

        {!this.context.isDesktop && <div className="mobile-slides">
          <div className="page-subtitle">
            <i>the audio-visual exhibition Skin Remembers: stories and identities of the few</i>
            <br />
            <i style={{ color: greyText }} >Om den audiovisuelle utstillingen Skin Remembers</i>
          </div>
          {slides}</div>}



        {this.context.isDesktop && <Slider slides={slides} />}


        <PageTitle>ABOUT</PageTitle>

        {/* {this.context.isDesktop && <div className="page-subtitle">
          <i>the audio-visual exhibition Skin Remembers: stories and identities of the few</i>
          <br />
          <i style={{ color: greyText }} >Om den audiovisuelle utstillingen Skin Remembers</i>
        </div>
        } */}
      </PageContainer>
    );
  }
}

export default About;
